import React from "react";
import PaymentPlansLayout from "../../home/components/payment-plans-layout";

function PaymentStepTwo(props) {
  const viewState = {
    showActions: false,
    showLinkPaymentMethodButton: true,
    showSelect: true,
    panelClass: "col-md-12",
    paymentClass: "col-md-7"
  };

  return (
    <div id="make-payment-step-2">
      <h4>Select a payment method</h4>

      <PaymentPlansLayout
        showDetails={true}
        paymentMethods={props.paymentMethods}
        handleShow={props.handleShow}
        viewState={viewState}
        setPaymentMethod={props.setPaymentMethod}
        addPaymentMethod={props.addPaymentMethod}
        selectedPaymentMethod={props.selectedPaymentMethod}
        emptyStepOption={props.emptyStepOption}
        currentPlan={props.currentPlan}
        component={props.component}
      />
    </div>
  );
}

export default PaymentStepTwo;



// WEBPACK FOOTER //
// ./src/home/components/payment-step-two.js